import { contactUsEmail } from '../util/constants';

export const ACCESS_ERROR_MESSAGES = {
  title: 'Access Required',
  descriptionBeforeSupport: 'You do not currently have access to this content. Please contact ',
  descriptionAfterSupport: ' for assistance.',
  supportLinkLabel: contactUsEmail,
  ctaLabel: 'Back to home',
} as const;
